import React, { useState, useEffect } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import useWindow from '../../hooks/useWindow'
import { singleDoubleChartWidth, chartHeight, post2 } from '../../services';
import exportingModule from "highcharts/modules/exporting";
import exportDataModule from 'highcharts/modules/export-data'
exportingModule(Highcharts);
exportDataModule(Highcharts);


export const BarChart = ({ param }) => {
    const [options, setOptions] = useState({})
    const size = useWindow()

    useEffect(() => {
        const { title, categories, series, is_percentage } = param
        const options = {
            chart: {
                type: 'bar',
                width: size.width - 90,
                height: 200,
            },
            exporting: {
                buttons: {
                    contextButton: {
                        enabled: true,
                        align: 'left',
                        menuItems: ["downloadPNG", "downloadPDF", "downloadCSV", "separator",
                            {   
                                text: 'Send Email', 
                                onclick: function() {
                                    const csv = this.getCSV()
                                    const html = this.getSVG()
                                    const title = this.getFilename()
                                    post2('user/export_file', { csv, html, title })
                                } 
                            }
                        ]
                    }
                }
            },
            legend: { enabled: false },
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: true,
                        color: '#000',
                        style: { fontWeight: 'bolder' },
                        formatter: function() { 
                            return `${this.series.userOptions.name}: ${is_percentage ? `${(this.y*100).toFixed(1)}%` : this.y}`
                        },
                        inside: true
                    },
                    pointPadding: 0.1,
                    groupPadding: 0
                }
            },
            xAxis: { title: { text: '' }, categories },
            yAxis: { title: { text: '' } },
            title: { text: title },
            series
        }
        setOptions(options)
        // console.log(options)
    }, [param, size])

    return <div className='row-center'>
        <HighchartsReact highcharts={Highcharts} options={options} />
    </div>

}